import api from './utilBackoffice';

const controller = 'RedeLojaExcecaoRenegociacao';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  Update: dto => {
    return api.Axios.Post(url + '/Atualiza', dto);
  },
  Create: dto => {
    return api.Axios.Post(url, dto);
  }
});
